<template>
	<div class="timetable">
		<Header title="监考查询"></Header>
		<div class="textbook_select" v-if="schoolCode == '10689'">
			<div class="sem-drop">
				<div @click="semPicker = true">
					<p>{{ this.xnxqtext }}</p>
					<i></i>
				</div>
			</div>
			<van-popup v-model="semPicker" position="bottom">
				<van-picker show-toolbar :columns="xnxqOption" @cancel="semPicker = false" @confirm="semConfirm" :item-height="itemHeight" />
			</van-popup>
		</div>
		<NOdata v-if="this.arrList1.length == 0 && schoolCode=='10689' " title="暂无监考数据或不在时间范围内~"></NOdata>
		<NOdata v-if="this.arrList1.length == 0 && schoolCode!='10689'" title="暂无监考数据~"></NOdata>
		<div class="invi" v-else>
			<div class="content_in" v-for="(item,index) in arrList1" :key="index">
				<div class="left_box">
					<span class="span">{{item.courseName}}</span>
					<span v-if="schoolCode=='4748'">
						<span>考场号：{{item.kaochanghao}}</span>
						<span>监考所属上课院系：{{item.yxmc}}</span>
					</span>
					<span class="span1">监考类型:{{item.jklx}}</span>
					<span>地点:{{item.place}}</span>
					<span>时间:{{item.time}}</span>
					<span v-if="schoolCode=='10759'">其他监考人员:{{item.otherjkls}}</span>
					<span v-if="schoolCode=='10759'" @click="jkrsViwe(item)">考生数:<label>{{item.ksrs}}</label></span>
				</div>
				<!-- <div class="right_box"><i></i></div> -->
			</div>
		</div>
		<van-popup v-model="popShow_student" class="popup_student">
      <h3>
        <i class="close-pop" @click="popShow_student = false"></i>考生名单
      </h3>
      <div class="student-tittle-div">
        <ul class="ul-student">
          <li class="li-student">学号</li>
		  <li class="li-student">姓名</li>
          <li class="li-student">班级</li>
		  <li class="li-student">准考证号</li>
        </ul>
      </div>

      <div
        class="student-context-div "
        v-for="(item, index) in studentsList"
        :key="index"
      >
        <ul v-if="index % 2 == 0" class="ul-student-context div-backclor1">
          <li class="li-student-context "><label>{{ item.studentnb }}</label></li>
          <li class="li-student-context"><label style="padding-left: 5px;">{{ item.stundentname }}</label></li>
          <li class="li-student-context"><label>{{ item.classname }}</label></li>
		  <li class="li-student-context"><label style="padding-left: 5px;">{{ item.zkzh }}</label></li>
        </ul>
        <ul v-if="index % 2 != 0" class="ul-student-context div-backclor2">
		   <li class="li-student-context "><label>{{ item.studentnb }}</label></li>
          <li class="li-student-context"><label style="padding-left: 5px;">{{ item.stundentname }}</label></li>
          <li class="li-student-context"><label>{{ item.classname }}</label></li>
		  <li class="li-student-context"><label style="padding-left: 5px;">{{ item.zkzh }}</label></li>
        </ul>
      </div>
    </van-popup>
	</div>
</template>

<script>
import { Api } from '../../../utils/axios'
	export default{
		data(){
			return{
				casLogin:sessionStorage.getItem('casLogin'),
				arrList1:[],
				schoolCode:'',
				popShow_student:false,
				studentsList:[],
				semPicker: false,
				itemHeight: 35,
				xnxqOption: [],
				xnxqval: '',
				xnxqtext:''
			}
		},
		methods:{
			async Invig(){
				const param = {
					xnxqid:this.xnxqval
				}
				const res = await Api.teachInvigilatorInquiry(param)
				this.arrList1 = res.data;
			},
			jkrsViwe(item){
				this.studentsList = [];
				this.popShow_student = true;
				this.getKsStudent(item.orderid);
			},
			async getKsStudent(orderid){
				const params = {
					parmkeyid:orderid
				};
				const res = await Api.teachInvigilatorInquiry_findStudent(params);
				if(res.code=='1'){
					this.studentsList = res.data;
				}
			},
			async getXnxq() {
				const res = await Api.findDictionry({ zzdtype: "xnxq" });
				if (res.code == "1") {
					this.xnxqOption = res.data.xnxq.map((item, index) => {
					if ( item.isdqxq == '1') {
						this.xnxqval = item.xnxq01id;
						this.xnxqtext = item.xqmc
					}
					return {
						text: item.xqmc,
						value: item.xnxq01id
					};
					})
				}
				this.xnxqOption.unshift({text:'全部',value:''})
				this.Invig();
			},
			semConfirm(e, val) {
				this.semPicker = false;
				this.xnxqtext = e.text
				this.xnxqval = e.value;
				this.Invig()
			},
		},
		created() {
			this.schoolCode=sessionStorage.getItem('schoolCode')
			if(this.schoolCode == '10689'){
				this.getXnxq();
			}else{
				this.Invig()
			}

		},
	}
</script>

<style lang="less" scoped>
	.title{
		line-height: 34px;
		width: 90%;
		margin: 10px auto;
	}
	.title a {
		text-decoration: none;
		color: @attendance-color-4;
		font-size: 18px;
		font-weight: 600;
	}

	.title a i {
		text-decoration: none;
		color: @attendance-color-4;
		vertical-align: middle;
		display: inline-block;
		width: 20px;
		height: 20px;
		background: url(../../../assets/images/back_left.png)center center no-repeat;
		background-size: 100%;
		margin-right: 5px;
	}
	.invi{
		width: 90%;
		margin: 0 auto;
		margin-top: 20px;
	}
	.invi .content_in{
		width: 100%;
		min-height: 82px;
		margin-top: 20px;
		border-radius: 5px;
		background: url(../../../assets/images/gray_bg.png) center center no-repeat;
		background-size: 100% 100%;
	}
	.invi .content_in .left_box{
		width: 90%;
		height: 100%;
		margin-left: 20px;
		padding: 10px 0;
	}
	.invi .content_in .left_box span{
		display: block;
	}

	.invi .content_in .left_box span label{
		color: blue;
	}
	.span1{
	display: none;
	}
	.invi .content_in .left_box .span{
		color: @attendance-color-1;
		font-weight:600;
		/* overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap; */
	}
	.invi .content_in .left_box span:nth-child(2),.content_in .left_box span:nth-child(3),.content_in .left_box span:nth-child(4),.content_in .left_box span:nth-child(5),.content_in .left_box span:nth-child(6){
		color: @attendance-color-2 ;
		font-size: 12px;
		padding-top: 4px;
	}
	.invi .content_in .right_box{
		width: 25%;
		height: 100%;
		float: right;
	}
	.invi .content_in .right_box i{
		display: inline-block;
		margin-top:35px;
		margin-left: 60px;
		width: 9px;
		height: 13px;
		background: url(../../../assets/images/back_right.png)center center no-repeat;
		background-size: 100%;
	}
	.timetable .van-popup.van-popup--center {
		box-sizing: border-box;
		padding: 20px 10px 10px;
		width: 90%;
		border-radius: 5px;
}

.timetable .van-popup.van-popup--center .popup-content {
  margin-bottom: 20px;
}
.timetable .van-popup.van-popup--center .popup-content > h2 {
  color: @attendance-color-1;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}
.timetable .van-popup.van-popup--center .popup-content > div {
  color: @attendance-background-color-1;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
.timetable .van-popup.van-popup--center .popup-content > p {
  color: @attendance-color-2;
  font-size: 16px;
  line-height: 30px;
}
	.popup_student {
  i.close-pop {
    background: url(../../../../static/img/close.png) no-repeat center;
    position: absolute;
    right: 0;
    top: -10px;
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
    padding: 10px;
  }
}

.set-part {
  display: flex;
  justify-content: space-between;
}
.set-part > div {
  width: 48%;
}
.set-part-p {
  text-align: left;
}
.timetable .ul-student {
  width: 99%;
}
.timetable .li-student {
  width: 25%;
  float: left;
  font-size: 15px;
}
.student-tittle-div {
  margin-top: 10px;
}
.student-context-div {
  margin: 0px;
}
.li-student-context {
  width: 25%;
  float: left;
  font-size: 12px;
  color: black;
}
.ul-student-context {
  width: 99%;
  line-height: 20px;
}
.div-backclor1 li {
  background-color: gainsboro;
}
.div-backclor2 li {
  background-color: antiquewhite;
}
.my-swipe {
  width: 100%;
  height: 100%;
  .van-swipe-item {
    padding: 8px 4px;
    box-sizing: border-box;
    color: #fff;
    margin-right: 1px;
  }
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}
.textbook_select {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid @attendance-border-color-6;
    padding: 20px 0 7px;
}
.textbook_select select {
    border: 0;
    background: 0;
    outline: 0;
}

.textbook_select .sem-drop {
    width: 80%;
}
.textbook_select .van-picker-column__item {
    margin: 0 30%;
}
.textbook_select .sem-drop > div {
    width: 45%;
}
.textbook_select .van-popup.van-popup--bottom {
    border-radius: 5px 5px 0 0;
}
.textbook_select .sem-drop p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
}
.textbook_select .sem-drop,
.textbook_select .sem-drop div {
    display: flex;
    align-items: center;
    color: @attendance-color-2;
    font-size: 14px;
    justify-content: center;
}
.textbook_select .sem-drop > div i {
    background: url(../../../../static/img/Triangle.png) no-repeat center;
    width: 10px;
    height: 10px;
    background-size: 10px 8px;
    margin-left: 5px;
}
.textbook_select .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
    font-weight: 600;
    color: @attendance-color-1;
}

.textbook_select .van-picker__columns::before {
    width: 140px;
    height: 1px;
    background-color: @attendance-background-color-2;
    content: '';
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
}
.textbook_select .van-picker__columns::after {
    width: 140px;
    height: 1px;
    background-color: @attendance-background-color-2;
    content: '';
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Invigilate/invigilate.vue